import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const getAssets = createAsyncThunk("getAssets", async (_, { rejectWithValue }) => {
     try {
          const response = await axiosHttp.get("tms/assets?page=1&limit=10");
          console.log("ffff", response?.data);
          return response?.data;
     } catch (err) {
          if (!err.response) throw err;
          return rejectWithValue(err.response.data);
     }
});

const GetAssetsSlice = createSlice({
     name: "GetAssetsSlice",
     initialState: {
          assets: [],
          assetsLoading: false,
          assetsError: null,
     },
     reducers: {
          resetAssets: (state) => {
               state.assets = [];
               state.assetsLoading = false;
               state.assetsError = null;
          },
     },
     extraReducers: (builder) => {
          builder.addCase(getAssets.pending, (state) => {
               state.assetsLoading = true;
               state.assetsError = null;
          });
          builder.addCase(getAssets.fulfilled, (state, action) => {
               state.assetsLoading = false;
               state.assets = action.payload;

          });
          builder.addCase(getAssets.rejected, (state, action) => {
               state.assetsLoading = false;
               state.assetsError = action.payload?.data;
          });
     },
});

export const { resetAssets } = GetAssetsSlice.actions;
export default GetAssetsSlice.reducer;